import { useState, useEffect } from "react";
import "./more.css";

export default function More({ editData }) {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (editData) {
      setForm(editData);
    }
  }, [editData]);

  const handleChange = (name) => {
    setForm((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  return (
    <div className="moreinfo_container">
      {[
        ["individual_heating", "ԱՆՀԱՏԱԿԱՆ ՋԵՌՈՒՑՈՒՄ"],
        ["equipment", "ՏԵԽՆԻԿԱ"],
        ["conditioner", "ՕԴՈՐԱԿԻՉ"],
        ["outdoor_balcony", "ԲԱՑ ՊԱՏՇԳԱՄԲ"],
        ["central_heating", "ԿԵՆՏՐՈՆԱՑՎԱԾ ՋԵՌՈՒՑՈՒՄ"],
        ["furniture", "ԿԱՀՈՒՅՔ"],
        ["elevator", "ՎԵՐԵԼԱԿ"],
        ["basement", "ՆԿՈՒՂ(-1)"],
        ["kitchen", "ԱՌԱՆՁԻՆ ԽՈՀԱՆՈՑ"],
        ["storage_room", "ԽՈՐԴԱՆՈՑ"],
        ["underfloor_heating", "ՏԱՔԱՑՎՈՂ ՀԱՏԱԿ"],
        ["sunny_side", "ԱՐԵՎԿՈՂ"],
        ["beautiful_view", "ԳԵՂԵՑԻԿ ՏԵՍԱՐԱՆ"],
        ["park", "ԶԲՈՍԱՅԳԻ"],
        ["playground", "ԽԱՂԱՀՐԱՊԱՐԱԿ"],
        ["garage", "ԱՎՏՈՏՆԱԿ"],
        ["parking", "ԱՎՏՈՀԱՆԳՐՎԱՆ"],
        ["two_sided", "ԵՐԿԿՈՂՄԱՆԻ"],
        ["pool", "ԼՈՂԱՎԱԶԱՆ"],
        ["attic", "ՁԵՂՆԱՀԱՐԿ"],
      ].map(([key, label]) => (
        <div key={key}>
          <input
            type="checkbox"
            name={key}
            id={key}
            checked={!!form[key]}
            onChange={() => handleChange(key)}
          />
          <label htmlFor={key}>{label}</label>
        </div>
      ))}
    </div>
  );
}
